<!-- 代理商列表 -->
<template>
    <div class="container">
        <div class="header">
            <Input class="w200 mr-24 mb-24" type="text" v-model="storePrams.keyword" placeholder="搜索" ></Input>
            <Select
                class="w200 mr-24 mb-24" v-model="storePrams.level" clearable filterable placeholder="代理商等级" >
                <Option v-for="item in levelList" :value="item.id" :key="item.id" >{{ item.level_name }}</Option >
            </Select>
            <Select class="w200 mr-24 mb-24" v-model="storePrams.status" clearable filterable placeholder="代理商状态" >
                <Option v-for="item in statusList" :value="item.id" :key="item.id" >{{ item.name }}</Option >
            </Select>
            <Button class="theme-bg mb-24" icon="ios-search" type="warning" @click="goSearch" >确定搜索</Button >
        </div>
        <div class="content">
            <div>
                <Button class="theme-bg mb-24" icon="md-add-circle" type="warning" @click="goModal" >新增代理商</Button >
                <Table ref="selection" :columns="columnsTable" :data="dataTable" border @on-selection-change="changeSelection"  >
                    <template slot-scope="{ index }" slot="id">
                        <div>{{ index + 1 }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="region">
                        <div> {{ row.region[0].province }}{{ row.region[0].city }}{{ row.region[0].county }} </div>
                    </template>
                    <template slot-scope="{ row }" slot="status">
                        <i-switch v-model="row.status" size="large" true-color="#FF761D" :true-value="1" :false-value="2" @on-change="changeStatus(row, $event)" >
                            <span slot="open">正常</span>
                            <span slot="close">禁用</span>
                        </i-switch>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="primary" ghost label="small" @click="goModal(row)">编辑</Button >
                            <Button type="error" ghost label="small" @click="goDel(1, row)">删除</Button >
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <div>
                    <Checkbox class="checkbox-ml" v-model="del_value" @on-change="handleSelectAll" >全选</Checkbox >
                    <span class="mr-24 ml-24" >已经选择{{ delData.length }}个</span >
                    <Button type="error" ghost label="large" @click="goDel(0)" >删除</Button >
                </div>
                <Page :current="storePrams.page" :page-size="storePrams.limit" :total="total" show-elevator show-total @on-change="pageChange"/>
            </div>
        </div>
        <!-- 新增/编辑 -->
        <Modal v-model="modals" :title="modalTitle" width="600" :mask-closable="false" >
            <div>
                <Form :model="formData" label-position="right" :label-width="160" >
                    <FormItem label="授权编号：">
                        <Input class="w200" type="text" v-model="formData.agent_number" placeholder="请输入授权编号" ></Input>
                        <Tooltip  max-width="250" placement="right"  theme="light" >
                            <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D" />
                            <div slot="content">
                                <p> 代理(经销)商的授权编号,已自动生成一个,也可以手工填写 </p>
                            </div>
                        </Tooltip>
                    </FormItem>
                    <FormItem label="代理（经销）商名称：">
                        <Input class="w200" type="text" v-model="formData.agent_name" placeholder="请输入代理（经销）商名称" ></Input>
                        <Tooltip  max-width="250" placement="right" theme="light" >
                            <Icon class="ml-24 cursor-p" type="md-help-circle" size="20"  color="#FF761D" />
                            <div slot="content">
                                <p>公司填写公司名,个人填写真实姓名</p>
                            </div>
                        </Tooltip>
                    </FormItem>
                    <FormItem label="手机号：">
                        <Input class="w200" type="text" v-model="formData.mobile" placeholder="请输入手机号" ></Input>
                    </FormItem>
                    <FormItem label="代理商等级：">
                        <Select class="w200" v-model="formData.level_id" clearable filterable placeholder="请选择代理商等级" >
                            <Option v-for="item in levelList" :value="item.id" :key="item.id" >{{ item.level_name }}</Option >
                        </Select>
                        <Tooltip max-width="250" placement="right" theme="light" >
                            <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D" />
                            <div slot="content">
                                <p> 没有请提前添加<span class="t-color" >代理商等级</span > </p>
                            </div>
                        </Tooltip>
                    </FormItem>
                    <FormItem label="负责区域：">
                        <div class="region_div" v-for="(item, index) in formData.region" :key="index" >
                            <Cascader class="w200 mr-24" :data="cityList" v-model="itemData.regionArray[index]" placeholder="请选择所在城市"
                                @on-change=" (value, selectedData) => { changeCity(value, selectedData, item); } "
                            ></Cascader>
                            <img class="width_height_20 cursor-p" v-if="formData.region.length > 1" src="../../assets/delete.png" @click="delRegion(index)" />
                        </div>
                        <Button class="theme-bg" icon="md-add-circle" type="warning" @click="addRegion" >添加负责区域</Button >
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button class="theme-bg" type="warning" @click="submitModal">确定</Button >
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    agent_list,
    agent_save,
    agent_delete,
    agent_number,
    agent_status,
} from "@/api/index";
import { agent_level_select } from "@/api/select";
export default {
    data() {
        return {
            itemData: {
                regionArray: [],
            },
            storePrams: {
                page: 1,
                limit: 10,
                keyword: "",
                level: "",
                status: "",
            },
            total: 0,
            levelList: [],
            statusList: [
                { id: 1, name: "正常" },
                { id: 2, name: "禁用" },
            ],
            columnsTable: [
                { type: "selection", width: 60, align: "center" },
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "代理(经销)商名称", key: "agent_name", align: "center", },
                { title: "授权编号", key: "agent_number", align: "center" },
                { title: "负责区域", slot: "region", align: "center" },
                { title: "手机号", key: "mobile", align: "center" },
                { title: "级别", key: "level_id", align: "center" },
                { title: "状态", slot: "status", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "300px", },
            ],
            dataTable: [],
            formData: {
                id: "",
                agent_number: "",
                agent_name: "",
                mobile: "",
                level_id: "",
                region: [
                    {
                        province: "",
                        city: "",
                        county: "",
                        province_value: "",
                        city_value: "",
                        county_value: "",
                    },
                ],
            },
            modals: false,
            modalTitle: "",
            // selection
            del_id: "",
            delData: [],
            del_value: false,
            cityList: [],
        };
    },
    mounted() {
        this.getList();
        this.getAgentSelect();
        if (localStorage.getItem("cityList")) {
            this.cityList = JSON.parse(localStorage.getItem("cityList"));
        }
    },
    methods: {
        getList() {
            agent_list(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        // 搜索
        goSearch() {
            this.getList();
        },
        changeCity(value, selectedData, item) {
            if (selectedData.length > 0) {
                item.province = selectedData[0].label;
                item.province_value = selectedData[0].value;
                item.city = selectedData[1].label;
                item.city_value = selectedData[1].value;
                item.county = selectedData[2].label;
                item.county_value = selectedData[2].value;
            } else {
                item.province = "";
                item.city = "";
                item.county = "";
            }
        },
        getAgentSelect() {
            agent_level_select().then((res) => {
                this.levelList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 确定
        submitModal() {
            let region = this.formData.region;
            var isloading = true;
            region.forEach((item) => {
                if (item.city == "") {
                    isloading = false;
                    return this.$Message.error(
                        "请完善负责区域信息!!!(不可为空)"
                    );
                }
            });
            if (!this.formData.agent_name) {
                this.$Message.error("请输入代理（经销）商名称");
                return;
            }
            if (!this.formData.level_id) {
                this.$Message.error("请选择代理商等级");
                return;
            }
            const phoneReg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
            if (!phoneReg.test(this.formData.mobile)) {
                this.$Message.error("请输入手机号");
                return;
            }
            if (isloading) {
                agent_save(this.formData).then((res) => {
                    this.getList();
                    this.modals = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
            }
        },
        // 取消
        cancelModal() {
            this.modals = false;
        },
        // 新增/编辑
        goModal(row) {
            if (row.id) {
                this.modalTitle = "编辑代理商";
                this.formData.id = row.id;
                this.formData.agent_number = row.agent_number;
                this.formData.agent_name = row.agent_name;
                this.formData.mobile = row.mobile;
                this.formData.level_id = row.level_id;
                this.formData.region = row.region;
                this.itemData.regionArray = row.region.map((item) => [
                    item.province_value,
                    item.city_value,
                    item.county_value,
                ]);
            } else {
                this.modalTitle = "新增代理商";
                this.formData.id = "";
                this.formData.agent_name = "";
                this.formData.mobile = "";
                this.formData.level_id = "";
                this.formData.region = [
                    {
                        province: "",
                        city: "",
                        county: "",
                        province_value: "",
                        city_value: "",
                        county_value: "",
                    },
                ];
                this.itemData.regionArray = [];
                agent_number().then((res) => {
                    this.formData.agent_number = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
            }
            setTimeout(() => {
                this.modals = true;
            }, 300);
        },
        // 删除
        goDel(index, row) {
            if (index == 0 && this.delData.length == 0) {
                this.$Message.error("请选择");
                return;
            }
            let that = this;
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？一经删除无法复原",
                onOk: () => {
                    if (index == 0) {
                        var del_id = [];
                        this.delData.forEach((item) => {
                            del_id.push(item.id)
                        });
                        this.del_id = del_id.join(",");
                        agent_delete({ id: this.del_id }).then((res) => {
                            that.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                    } else if (index == 1) {
                        agent_delete({ id: row.id }).then((res) => {
                            that.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                    }
                },
                onCancel: () => {},
            });
        },
        // 修改状态
        changeStatus(row, e) {
            let that = this;
            this.$Modal.confirm({
                title: "提示",
                content: "确认修改代理商状态吗？",
                onOk: () => {
                    agent_status({ id: row.id }).then((res) => {
                        that.getList();
                        this.$Message.success(res.msg);
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
                },
                onCancel: () => {
                    that.getList();
                },
            });
        },
        // selection
        changeSelection(e) {
            this.delData = e;
            if (this.dataTable.length === e.length) {
                this.del_value = true;
            } else {
                this.del_value = false;
            }
        },
        handleSelectAll(e) {
            if (e == true) {
                this.delData = this.dataTable;
                this.$refs.selection.selectAll(true);
            } else {
                this.$refs.selection.selectAll(false);
            }
        },
        addRegion() {
            this.formData.region.push({
                province: "",
                city: "",
                county: "",
                province_value: "",
                city_value: "",
                county_value: "",
            });
        },
        delRegion(index) {
            if (this.formData.region.length > 1) {
                this.itemData.regionArray.splice(index, 1);
                this.formData.region.splice(index, 1);
            }
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}
.region_div {
    display: flex;
    align-items: center;
    margin: 0 0 12px 0;
}
.width_height_20 {
    width: 20px;
    height: 20px;
}
::v-deep .ivu-checkbox {
    margin-right: 24px;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框 */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>